/** How the file explorer lays out its files: a table or a gallery of tiles. */
export const FILE_VIEW_MODES = ["list", "gallery"] as const;
export type FileViewMode = (typeof FILE_VIEW_MODES)[number];
